import React from "react";

function Error() {
	return (
		<div className="online-donation success">
			<div className="home-banner">
				<img
					src="/assets/images/atm_banner.png"
					title="ATM Global Group"
					width="800"
					loading="eager"
					height="180"
					alt=""
				/>
			</div>

			<div className="success-box">
				<div className="success-img">
					<img src="/assets/images/fail.gif" alt="" />
				</div>
				<h2>Something went wrong !! </h2>
				<p style={{ fontSize: 17 }}>An unexpected error occured</p>

				<p>Kindly contact coordinator if this issue persists.</p>

				<br />
				<div className="success-btns">
					<a href="/">Go to Home Page</a>{" "}
				</div>
			</div>
		</div>
	);
}

export default Error;
